<template>
    <v-contextmenu ref="contextmenu">
        <v-contextmenu-item @click="handleClick">自定义菜单项</v-contextmenu-item>
    </v-contextmenu>
</template>

<script>
    export default {
        methods: {
            handleClick() {
                // 在这里处理菜单项的点击事件
                console.log('自定义菜单项被点击');
            }
        }
    }
</script>
